import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

const CountdownTimer = ({ targetDate }) => {
  const { t } = useLanguage();
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const now = new Date();
    const target = new Date(targetDate);
    const difference = target - now;

    if (difference <= 0) {
      return null;
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);
      
      if (!newTimeLeft) {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  if (!timeLeft) {
    return null;
  }

  const formatTime = () => {
    const parts = [];
    
    if (timeLeft.days > 0) {
      parts.push(`${timeLeft.days}${t('countdown.days_short')} `);
    }
    if (timeLeft.hours > 0 || timeLeft.days > 0) {
      parts.push(`${String(timeLeft.hours).padStart(2, '0')}:`);
    }
    parts.push(`${String(timeLeft.minutes).padStart(2, '0')}:`);
    parts.push(`${String(timeLeft.seconds).padStart(2, '0')}`);
    
    return parts.join('');
  };

  return (
    <span className="countdown-timer">
      {t('countdown.in')} {formatTime()}
    </span>
  );
};

export default CountdownTimer;